module.exports = __webpack_public_path__ + "media/images/lb/746-112226877aa8eca92ac0d5326cb657e6.svg";